// @flow

import './index.scss';
import * as React from 'react';
import { getTrackBackground } from 'react-range';

type Props = {
    props: any,
    values: number[],
    children: any
};

const Track = ({ props, values, children }: Props): React.Node => (
    <div
        className="RangeTrack"
        onMouseDown={props.onMouseDown}
        onTouchStart={props.onTouchStart}
        style={props.style}
        role="button"
    >
        <div
            className="RangeTrack__bar"
            ref={props.ref}
            style={{
                background: getTrackBackground({
                    values,
                    colors : ['#9e9e9e', '#ff9d1d', '#9e9e9e', '#9e9e9e'],
                    min    : 0,
                    max    : 100000
                })
            }}
        >
            {children}
        </div>
    </div>
);

export default Track;
